import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-gs-application',
	templateUrl:'./ApplicationPage.html',
	styles: [],
	styleUrls:['./ApplicationPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class ApplicationPage
{
	mdContent_485 = `\`\`\`java
@NgApp(value = "my-app", bootComponent = MyHomePage.class)
public class MyApplication extends NGApplication<MyApplication> {
    public MyApplication() {
        getOptions().setTitle("My App");
    }
}
\`\`\``;
}
